<template>
  <el-container class="index-con">
    <el-aside :class="showclass">
      <leftnav></leftnav>
    </el-aside>
    <el-container class="main-con">
      <el-header class="index-header" height="50px">
        <navcon></navcon>
      </el-header>
      <el-main class="index-main">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
// 导入组件
import navcon from "../components/navcon.vue";
import leftnav from "../components/leftnav.vue";
export default {
  name: "index",
  data() {
    return {
      showclass: "asideshow",
      showtype: false,
    };
  },
  // 注册组件
  components: {
    navcon,
    leftnav,
  },
  methods: {
    getCol(){
      if(localStorage.getItem('collapse') == 'true'){
        this.showclass = "aside";
      } else {
        setTimeout(() => {
          this.showclass = "asideshow";
        }, 300);
      }
    }
  },
  mounted(){
    this.getCol()
  },
  created() {
    // 监听
    this.$root.Bus.$on("toggle", (value) => {
      if (!value) {
        this.showclass = "asideshow";
        localStorage.setItem('isActive','1')
      } else {
        setTimeout(() => {
          this.showclass = "aside";
          localStorage.setItem('isActive','1')
        }, 300);
      }
    });
  },
};
</script>
<style scoped >
.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.aside {
  width: 64px !important;
  height: 100%;
  /* background-color: #0f215d; */
  margin: 0px;
}

.aside >>>.element-icons{
  font-size: 20px;
}
/* .aside >>> li{
  height: 45px!important;
  line-height: 45px!important;
} */
.asideshow {
  width: 240px !important;
  height: 100%;
  /* background-color: #0f215d; */
  margin: 0px;
}
.index-header,.index-main {
  padding: 0px;
}
.index-main {
  padding: 0px;
  background-color:#fbfbfb;
}
.index-main {
  border: 20px solid #fbfbfb;
  /* padding: 20px; */
}
</style>




// WEBPACK FOOTER //
// src/views/index.vue